
import { Component, Prop, Mixins, Watch, Ref } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import FormCard from "@/components/FormCard.vue";
import { QForm } from "quasar";
interface requestData {
  document_type: string | number;
  document_id: string;
  ticket_number: string;
}

@Component({
  components: {
    FormCard,
  },
})
export default class RequestDetailFormNew extends Mixins(FormValidator) {
  @Ref("form") form!: QForm;
  private base_bucket = process.env.VUE_APP_AWS_ASSETS;
  private id_comuna = process.env.VUE_APP_ID_COMUNA as string;
  protected formData: requestData = {
    document_type: "1",
    document_id: "",
    ticket_number: "",
  };

  options_document: object[] = [
    { label: "RUT", value: "1" },
    { label: "Pasaporte", value: "2" },
  ];

  @Watch("formData.document_type")
  private watchDocumentType(newValue: any) {
    if (newValue == 1 || newValue == "1") {
      this.formData.document_id = "";
    } else {
      this.formData.document_id = "";
    }
  }

  private mounted() { }


  formIsTicketNumber(value: string) {
    if (/^([0-9]+-[0-9]+)$|^[0-9]+$/g.test(value)) {
      return true;
    }
    return this.$t("El número del ticket no es válido");
  }

  private consultarTicket() {
    this.form.validate().then((valid: boolean) => {
      if (valid) {
        this.$router.push({
          name: "requestdetailsnew",
          params: {
            id_ticket: this.formData.ticket_number,
            rut: this.formData.document_id,
            tipo_doc: String(this.formData.document_type),
          },
        });
      } else {
        this.$q.notify({
          type: "negative",
          position: "top",
          message: this.$t("forms.correct_errors") as string,
        });
      }
    });
  }
}
